import { render, staticRenderFns } from "./CategoryArchive.vue?vue&type=template&id=4bf150a8&"
import script from "./CategoryArchive.vue?vue&type=script&lang=js&"
export * from "./CategoryArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports